import {
    ICalendarEventUpdateMutationParameters,
    ICalendarEventUpdateMutationResult,
} from "./calendarEventUpdateMutation";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue } from "../../utils/filters";

export type ICalendarEventUpdateFollowingRecurrenciesMutationParameters = ICalendarEventUpdateMutationParameters;

export type ICalendarEventUpdateFollowingRecurrenciesMutationResult = ICalendarEventUpdateMutationResult;

export const calendarEventUpdateFollowingRecurrenciesMutation: IApiMutationFunction<
    ICalendarEventUpdateFollowingRecurrenciesMutationParameters
> = ({ calendarEvent, data }) => {
    const { brief, ...rest } = data;
    return {
        method: "PATCH",
        url: `/calendar-events/${mapRelationalValue(calendarEvent)}/recurrencies/following`,
        data: {
            ...rest,
            briefId: mapRelationalValue(brief),
        },
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
    };
};

export const useCalendarEventUpdateFollowingRecurrenciesMutation = createApiMutationHook<
    ICalendarEventUpdateFollowingRecurrenciesMutationParameters,
    ICalendarEventUpdateFollowingRecurrenciesMutationResult
>(calendarEventUpdateFollowingRecurrenciesMutation);
